<div *ngIf="sliderVisible">
  <h3>{{ title }}</h3>
  <div class="slider-bottom-spacer">
    <nouislider
      [config]="sliderConfig"
      [(ngModel)]="sliderPositions"
      (ngModelChange)="onSliderChange($event)"
      name="slider"
      #slider>
    </nouislider>
  </div>
  <div *ngFor="let data of sliderData; let i = index" class="d1">
    <mat-form-field floatLabel="never" class="smInput">
      <input 
        [id]="'percent-slider-'+data.name+'_input'"
        style="font-size: 16px;"
        matInput
        name="sliderValue"
        type="number"
        [(ngModel)]="data.value"
        (blur)="updateSliders(i)">
      <span matSuffix>%</span>
    </mat-form-field>
    <span class="tag">&nbsp;- {{data.name | anessaTranslation: trigger}}</span>
  </div>
</div>
